module.exports = __webpack_public_path__ + "static/media/Ocean King.31552bde.jpg";